var OCS = OCS || {};
OCS.Interfaces = OCS.Interfaces || {};
OCS.Interfaces.DataTypeDefault = {
    /**
     * 
     * @param {String} variable
     * @returns {String}
     */
    get_variable_units: function (variable) {
        var data = this.get_data_variable(variable);
        return data[variable].units;
    },
    add_data_variable: function (data_in, variable) {
        Object.append(this.data(), data_in);
        var vars = this.get_variables();
        vars = vars.combine([variable]);
        return true;
    },
    get_data_variable: function (data_var, data_unit) {
        return this.data();
    },
    get_variables: function () {
        var metadata = this.get_info();
        return metadata.parm;
    },

    is_gridded: function () {
        return this.options.entry.json.info.grid;
    },
    is_valid: function() {
        return true;
    }
};